/**
 * accountHeader.component.tsx
 * Secured Communication
 *
 * Created by: Dylan Knight
 * Copyright (c) 2021 Secured Communications. All rights reserved.
 *
 */

import * as React from "react";
import { useNavigate } from "react-router-dom";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { ClickAwayListener, Divider, IconButton, MenuItem, MenuList, 
  Paper, Popper, Typography } from "@mui/material";

import { AuthContext } from "../auth/auth.context";
import { PermissionLevel } from "../models/auth";

interface Props {
  hideMenu?: boolean
}
export function AccountHeader(props: Props): React.ReactElement<any, any> {
  const context: AuthContext = React.useContext(AuthContext);
  const anchorRef = React.useRef<HTMLDivElement>(null);
  const [showAccountMenu, setShowAccountMenu] = React.useState<boolean>(false);
  const navigate = useNavigate();

  return <>
    <header ref={anchorRef} className="groups-header-nav">
      <Typography variant="h1" data-testid="account-name">{context.membership?.accountname || ""}</Typography>
      <span className="right-controls">
      {!props.hideMenu &&
        <IconButton size="small" aria-label="account-info-menu" aria-haspopup="true"
            disableRipple disableTouchRipple
            onClick={() => setShowAccountMenu(true)}>
          <ExpandMoreIcon />
        </IconButton>}
      </span>
    </header>
    <Popper
        className="popup-menu"
        open={showAccountMenu}
        anchorEl={anchorRef.current}
        modifiers={[{
          name: "preventOverflow",
          enabled: true,
          options: {
            altAxis: true,
            altBoundary: true,
            tether: true,
            rootBoundary: "document",
            padding: 8
          }
        }]}
        disablePortal={true} placement="bottom-end">
      <Paper>
        <ClickAwayListener onClickAway={() => setShowAccountMenu(false)}>
          <MenuList id="account-meta-menu">
            {context.can(PermissionLevel.WRITE, "profiles") && [
              <MenuItem key="members"
                  disableRipple disableTouchRipple
                  onClick={() => navigate("/admin/members")}>
                <span>Manage&nbsp;</span>
                <span> {context.membership?.accountname || "this company"}</span>
              </MenuItem>,
              <MenuItem key="invite"
                  disableRipple disableTouchRipple
                  onClick={() => navigate("/admin/invite")}>
                <span>Invite New Member</span>
              </MenuItem>,
              <Divider />
            ]}
            <MenuItem disableRipple disableTouchRipple
                onClick={() => navigate("/settings")}>
              <span>Authentication &amp; Settings</span>
            </MenuItem>
          </MenuList>
        </ClickAwayListener>
      </Paper>
    </Popper>
  </>;
  /*<MenuItem disableRipple disableTouchRipple
                onClick={() => history.push("/profile")}>Profile</MenuItem>
            */
}